module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"DRAFT":"Bozza","SENT":"Inviato","INPOSTPROCESSING":"In Post-Produzione","APPROVED":"Approvato","WAITING_APPROVAL":"In attesa di approvazione"},"en":{"DRAFT":"Draft","SENT":"Sent","INPOSTPROCESSING":"In Post-Production","APPROVED":"Approved","WAITING_APPROVAL":"Waiting approval"}}')
  delete Component.options._Ctor
}
